import { useCallback, useEffect, useState } from 'react';
import { instrumentApi } from '../../../../utils/api';

export default function useInsightDetail(insightId) {
    const [detail, setDetail] = useState(null);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(null);

    const reload = useCallback(async () => {
        if (!insightId) {
            setDetail(null);
            return;
        }
        setLoading(true);
        setError(null);
        try {
            const res = await instrumentApi.getInsightDetail(insightId);
            setDetail(res);
        } catch (err) {
            setError(err?.message || 'Không tải được nội dung báo cáo');
            setDetail(null);
        } finally {
            setLoading(false);
        }
    }, [insightId]);

    useEffect(() => {
        reload();
    }, [reload]);

    return { detail, loading, error, reload };
}
